export const validateAlias = async (
  value = '',
  excludeIds: number[] = [],
  validator: any,
  fieldName = 'alias'
) => {
  if (!value) {
    return;
  }

  // test if string is start and end with alphanumerics and contains only alphanumerics and '-'
  if (!/^[a-zA-Z0-9][\w-]+[a-zA-Z0-9]$/g.test(value)) {
    throw new Error(`${fieldName} must contains only alphanumerics and - symbol`);
  }

  let available = false;
  try {
    ({ data: available } = await validator(value, excludeIds));
  } catch (error) {
    console.error(error);
    console.warn(`Failed to check ${fieldName}`);
  }

  if (!available) {
    throw new Error(`This ${fieldName} already exists`);
  }
};
